export const formState = {
  name: "",
  phoneNumber: "",
  emailAddress: "",
  message: "",
};
